import { useState } from 'react';
import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
  Box,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';

import i18n from '../../utils/i18n';

export const QuestionLabelPopover = ({
  originalLabel,
}: {
  originalLabel: string;
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Popover placement="bottom" trigger="hover">
      <PopoverTrigger>
        <InfoOutlineIcon marginLeft={2} color="keyops.blue" cursor="pointer" />
      </PopoverTrigger>
      <PopoverContent maxW="550px">
        <PopoverArrow />
        <PopoverCloseButton color={'white'} />
        <PopoverBody
          whiteSpace="pre-line"
          background={'#1c1c1c'}
          color={'white'}
          borderRadius="8px"
          data-testid="question-label-popover"
          py={3}
        >
          <Box>
            <Text fontSize="xs" fontWeight="bold">
              {i18n.t(
                'engagementDetails.questionCards.labelReadabilityTooltip'
              )}
            </Text>
            <Text fontSize="xs" fontWeight="bold" mt={'4px'}>
              {i18n.t('engagementDetails.questionCards.originalLabelTooltip')}
            </Text>
            <Text
              fontSize="xs"
              fontStyle="italic"
              mt={1}
              style={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                WebkitLineClamp: expanded ? 'unset' : 2, // limit to 2 lines when not expanded
              }}
            >
              {originalLabel}
            </Text>
          </Box>
          <Text
            textAlign={'right'}
            fontSize={'xs'}
            color="keyops.blue"
            textTransform={'uppercase'}
            cursor={'pointer'}
            pt={1}
            onClick={(e) => {
              e.stopPropagation();
              setExpanded((prev) => !prev);
            }}
          >
            {expanded
              ? i18n.t('engagementDetails.questionCards.readLess')
              : i18n.t('engagementDetails.questionCards.readMore')}
          </Text>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
